"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var STORATE_KEY = "settings";
var LocalStorageStore = (function () {
    function LocalStorageStore() {
    }
    LocalStorageStore.prototype.getItem = function (key) { return localStorage.getItem(key); };
    LocalStorageStore.prototype.setItem = function (key, value) { localStorage.setItem(key, value); };
    return LocalStorageStore;
}());
var CacheStorage = (function () {
    function CacheStorage() {
    }
    CacheStorage.prototype.getItem = function (key) { return constants_1.environment.cache[key]; };
    CacheStorage.prototype.setItem = function (key, value) {
        return constants_1.environment.cache = __assign({}, constants_1.environment.cache, (_a = {}, _a[key] = value, _a));
        var _a;
    };
    return CacheStorage;
}());
var createStore = function () {
    if (typeof localStorage === "undefined") {
        return new CacheStorage();
    }
    else {
        return new LocalStorageStore();
    }
};
var store = createStore();
var storage = function () { return JSON.parse(store.getItem(STORATE_KEY) || "{}") || {}; };
var save = function (data) { return store.setItem(STORATE_KEY, JSON.stringify(data)); };
var get = function (key, defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    return storage()[key] || defaultValue || null;
};
exports.get = get;
var set = function (key, value) {
    var newStorage = storage();
    newStorage[key] = value;
    save(newStorage);
    return value;
};
exports.set = set;
var remove = function (key) {
    var newStorage = storage();
    delete newStorage[key];
    save(newStorage);
};
exports.remove = remove;
//# sourceMappingURL=settings.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/skiliko-sdk/lib/modules/settings.js
// module id = 846
// module chunks = 3